import { useCallback } from "react";
import { ClientPortfolioToolTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { InvestmentToolInput } from "web_myplann/Portfolio/Forms/InvestmentForm/investmentToolSchema";
import { useCommodityIdentificationOptions } from "web_myplann/Portfolio/Forms/ToolsShared/useToolIdentificationOptions";
import { useCryptocurrencyOptions } from "web_myplann/Portfolio/Helpers/useCryptocurrencyOptions";
import { moneyFormatter } from "web_myplann/Shared/Utils/moneyFormatters";

const TOOL_TYPE_LABELS =
	Resources.PortfolioDetail.LifeInsurance.InvestmentTool.Type;

export const useInvestmentToolRowLabels = () => {
	const { t } = useResource();
	const cryptocurrencyOptions = useCryptocurrencyOptions();
	const commodityOptions = useCommodityIdentificationOptions();

	return useCallback(
		(tool: InvestmentToolInput | undefined) => {
			if (!tool) {
				return { title: "", subtitle: "", rightText: undefined };
			}

			const options =
				tool.type === ClientPortfolioToolTypeEnum.Crypto
					? cryptocurrencyOptions
					: tool.type === ClientPortfolioToolTypeEnum.Commodity
						? commodityOptions
						: [];
			const identification =
				options.find((option) => option.value === tool.identification)?.label ??
				tool.identification ??
				"";
			const typeLabel = tool.type ? t(TOOL_TYPE_LABELS[tool.type]) : "";
			const name = tool.name?.trim() ?? "";

			return {
				title: name || identification || typeLabel,
				subtitle: name ? identification : "",
				rightText:
					tool.value === null
						? undefined
						: moneyFormatter(
								tool.value,
								t(Resources.Common.CurrencySign),
								undefined,
								0,
							),
			};
		},
		[t, cryptocurrencyOptions, commodityOptions],
	);
};
